import { getSupabase } from './client.js';
import { unwrap, unwrapList } from './errors.js';

export async function listNotifications({ page = 1, pageSize = 20, unreadOnly = false } = {}) {
  let q = getSupabase()
    .from('notifications')
    .select('id, type, title, body, link, read_at, created_at', { count: 'exact' })
    .order('created_at', { ascending: false })
    .range((page - 1) * pageSize, page * pageSize - 1);
  if (unreadOnly) q = q.is('read_at', null);
  return unwrapList(await q);
}

export async function unreadCount() {
  const res = await getSupabase().from('notifications').select('id', { count: 'exact', head: true }).is('read_at', null);
  if (res.error) throw res.error;
  return res.count ?? 0;
}

export const markRead = async (ids = null) => unwrap(await getSupabase().rpc('notifications_mark_read', { p_ids: ids }));

/** Realtime subscription for the signed-in user's new notifications. Returns an unsubscribe function. */
export function subscribeToNotifications(userId, onInsert) {
  const channel = getSupabase()
    .channel(`notifications:${userId}`)
    .on('postgres_changes', { event: 'INSERT', schema: 'public', table: 'notifications', filter: `recipient_id=eq.${userId}` }, (payload) => onInsert(payload.new))
    .subscribe();
  return () => { getSupabase().removeChannel(channel); };
}
